import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteImplantacaoEstoque } from '../service';
import {
  DELETE_IMPLANTACAO_ESTOQUE,
  DELETE_IMPLANTACAO_ESTOQUE_PENDING,
  DELETE_IMPLANTACAO_ESTOQUE_SUCCESS,
  DELETE_IMPLANTACAO_ESTOQUE_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteImplantacaoEstoque(action) {
  yield put({ type: DELETE_IMPLANTACAO_ESTOQUE_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.ESTOQUE_IMPLANTACAO_EXCLUIR);

  try {
    const a = yield call(deleteImplantacaoEstoque, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_IMPLANTACAO_ESTOQUE_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_IMPLANTACAO_ESTOQUE_FAILURE });

    if (error.response.status === 403) {
      AlertWarning('Implantação não pode ser excluída, pois já houve movimentação no estoque');
    } else {
      AlertError('Falha ao excluir o registro! Tente novamente...');
    }
  }
}

export default function* watchDeleteImplantacaoEstoque() {
  yield takeLatest(DELETE_IMPLANTACAO_ESTOQUE, sagaDeleteImplantacaoEstoque)
}
